import React from 'react';

// const CustomerTableComponentLoadable = React.lazy(() => import('./CustomerTableComponent'));
const EmployeeTableComponentLoadable = React.lazy(() => import('./EmployeeTableComponent'));
const VehiclesTableLoadable = React.lazy(() => import("./Vehicles/VehiclesTable"));
const ExceptionTableComponentLoadable = React.lazy(() => import('./ExceptionTableComponent'));
const CityTableComponentLoadable = React.lazy(() => import('./CityTableComponent'));
const EventTableComponentLoadable = React.lazy(() => import('./EventTableComponent'));
const TripRouteTableComponentLoadable = React.lazy(() => import('./TripRouteTableComponent'));
const CountryTableComponentLoadable = React.lazy(() => import('./CountryTableComponent'));
const RegionTableComponentLoadable = React.lazy(() => import('./RegionTableComponent'));
const DriverTableComponentLoadable = React.lazy(() => import('./DriverTableComponent'));
const ProductTableComponentLoadable = React.lazy(() => import('./ProductTableComponent'));
const OdaTableComponentLoadable = React.lazy(() => import('./OdaTableComponent'));
const StationTableComponentLoadable = React.lazy(() => import('./StationTableComponent'));
const VehiclesLoginDetailsLoadable = React.lazy(() => import('./VehiclesLoginDetails'));
const ShipperTableComponentLoadable = React.lazy(() => import('./ShipperTableComponent'));
const ConsigneeTableComponentLoadable = React.lazy(() => import('./ConsigneeTableComponent'));

export {

    EmployeeTableComponentLoadable,
    VehiclesTableLoadable,
    ExceptionTableComponentLoadable,
    CityTableComponentLoadable,
    EventTableComponentLoadable,
    TripRouteTableComponentLoadable,
    CountryTableComponentLoadable,
    RegionTableComponentLoadable,
    DriverTableComponentLoadable,
    ProductTableComponentLoadable,
    OdaTableComponentLoadable,
    StationTableComponentLoadable,
    VehiclesLoginDetailsLoadable,
    ShipperTableComponentLoadable,
    ConsigneeTableComponentLoadable
};

